"use strict";

var httpLib = require("./http-library.js");
var publicConfig = require("../public-config.js");
var reviewHost = publicConfig.external_address;

// private

function _readReviews(path, token, callback) {
  var params = {
    host: reviewHost,
    method: 'GET',
    path: "/v1/reviews/".concat(path),
    headers: {
      Authorization: "Bearer ".concat(token)
    }
  };
  httpLib.request(params, function (res) {
    callback(res);
  });
}
function _updateReview(reviewId, token, payload, callback) {
  var params = {
    host: reviewHost,
    method: 'PUT',
    path: "/v1/reviews/".concat(reviewId),
    headers: {
      Authorization: "Bearer ".concat(token)
    }
  };
  httpLib.request(params, function (res) {
    callback(res);
  }, payload);
}

// public
var Reviews = {
  /**
   *
   * @function
   * @name get review
   * @param {String}   - SSOid string
   * @param {String}   - Access token (retrived from sessions)
   * @param {Function} - Callback
   */

  read: function read(SSOid, token, callback) {
    var readReviews = _readReviews(SSOid, token, callback);
    return readReviews;
  },
  /**
   *
   * @function
   * @name get review
   * @param {String}   - reviewId string
   * @param {String}   - Access token (retrived from sessions)
   * @param {Object}   - payload
   * @param {Function} - Callback
   */

  update: function update(reviewId, token, payload, callback) {
    var updateReview = _updateReview(reviewId, token, payload, callback);
    return updateReview;
  }
};
module.exports = Reviews;